module.exports = __webpack_public_path__ + "img/icons4.6967332f.png";